import React from 'react';
import { Link } from 'gatsby';

import * as styles from './StickyWidget.module.scss';

export const StickyWidget: React.FC = () => {
	return (
		<Link
			to="https://clutch.co/profile/embiq?utm_source=widget&utm_medium=1&utm_campaign=widget&utm_content=logo#summary"
			target="_blank"
			className={styles.clutchFixed}
		>
			<div
				className={styles.clutchWidget}
				data-url="https://widget.clutch.co"
				data-widget-type="1"
				data-expandifr="true"
				data-height="auto"
				data-clutchcompany-id="1461021"
			>
				<iframe
					id="iframe-0.9115626543630231"
					width="100%"
					src="https://widget.clutch.co/widgets/get/1?ref_domain=www.embiq.com&amp;uid=1461021&amp;ref_path=/"
					height="auto"
					scrolling="no"
					data-lf-yt-playback-inspected-yegkb8lwvoyaep3z="true"
					title="[iFrameSizer]iframe-0.9461013312924982:0:0:mouseleave:572:6451"
				></iframe>
			</div>
		</Link>
	);
};
